<script>
	import Row from './Row.svelte';
	import {link} from 'svelte-spa-router'
</script>

<main>
	<Row klass="all-center bg-dots-xs">
		<div class="bg-dots-big">
			<h1 class="caps w-800 primary">Submit</h1>
			<p><a use:link={'/'}>Back to Open Call</a> <a target="_blank" use:link={'/terms-and-conditions'}>Terms & Conditions</a>
			</p>
			<p style="color: #666; max-width: none;">If you have issues uploading files in the form or if it takes longer than 5s to load the form, <a href="https://airtable.com/shrVo4Y6OWrh8aApV" target="_blank" style="outline: none; padding: 0; margin: 0; line-height: 1; display: inline;">please click here</a></p>
		</div>
	</Row>
	<Row klass="">
		<div>
			<script src="https://static.airtable.com/js/embed/embed_snippet_v1.js"></script><iframe class="airtable-embed airtable-dynamic-height" src="https://airtable.com/embed/shrVo4Y6OWrh8aApV?backgroundColor=red" frameborder="0" onmousewheel="" width="100%" height="3333" style="background: transparent; border: none;"></iframe>
		</div>
	</Row>
	<Row klass="all-center footer">
		<img src="../img/Oxford-University-logo.png" />
	</Row>

</main>

<style type="text/scss">
	main {
		max-width: clamp(1600px,1600px,90vw);
		margin: 0 auto;
	}
</style>